export default __webpack_public_path__ + "static/media/backoffice-dashboard.31fb6134.webp";